

















































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "./PointerMenu.vue";
import Loading from "./Loading.vue";

import CustomerJson from "../../shared/CustomerJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "FormCustomer",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Object,
    editable: Boolean,
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      details: null as CustomerJson | null,
      selectedRentalConditionTemplate: null as number | null,
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = this.data;
    },

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "generalCustomer", key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    data: function () {
      this.details = this.data;
    },

    /* submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          this.validation = validateSepaMandate(this.details);
        }
      }
    }, */
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
